import React from "react";
import "./MapSection.css";

const MapSection = () => {
  return (
    <div className="mapIframeWrapper">
      <div className="mapIframeContainer">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31355.631828299916!2d77.19141955896747!3d10.776499819809434!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba9b4dc1b3b85d3%3A0x9027e8eca63f7599!2sMoongiltholuvu%2C%20Tamil%20Nadu%20642202!5e0!3m2!1sen!2sin!4v1766597960963!5m2!1sen!2sin"
          style={{ border: 0 }}
          className="mapIframeFrame"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Moongiltholuvu Location Map"
        ></iframe>
      </div>
    </div>
  );
};

export default MapSection;
